import ChatOrPhoneIcon from './ChatOrPhoneIcon';

export default ChatOrPhoneIcon;
